/** Tag colors for software project technology chips (shared by Projects and legacy Experience). */
export function getCategoryColor(categoryTitle: string): string {
  switch (categoryTitle) {
    case 'Frontend':
      return '#e6f3e6';
    case 'Backend':
    case 'Backend & Core Engineering':
      return '#f3e6f3';
    case 'DevOps':
    case 'Cloud & DevOps':
      return '#fff3e6';
    case 'Soft Skills':
    case 'Leadership & Strategy':
      return '#ffe6e6';
    default:
      return '#f1f2f6';
  }
}

export function getCategoryBorderColor(categoryTitle: string): string {
  switch (categoryTitle) {
    case 'Frontend':
      return '#c8e6c8';
    case 'Backend':
    case 'Backend & Core Engineering':
      return '#e6c8e6';
    case 'DevOps':
    case 'Cloud & DevOps':
      return '#ffe6c8';
    case 'Soft Skills':
    case 'Leadership & Strategy':
      return '#ffc8c8';
    default:
      return '#d1d8e0';
  }
}
